import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import ArrowToolTip from "../../common/ArrowToolTip";
import HelpIcon from "../../Icons/HelpIcon";
import { FormControlLabel } from "material-ui/Form";
import Switch from "material-ui/Switch";
import { connect } from 'react-redux';

const styles = () => ({
  root : {
    display: "flex",
    alignItems: "center",
    marginRight: "0px",
  },

  item: {
    display: "flex",
    alignItems: "center",
    marginRight: "10px",
  },

  label: {
    padding: "4px 2px",
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "12px",
    marginRight: "0px",
  },

  switchBase: {
    height: "unset",
  },
});

/**
 * Salesforceの同期トグルのコントロール
 */
class SalesforceSyncControl extends React.Component {
  state = {
    disableSwitch: true,
    warningMessage: "",
    salesforceSyncFlag: false,
  }

  handleToggleSalesforceSyncFlag = (e) => {
    this.setState({
      salesforceSyncFlag: e.target.checked,
    });

    this.props.handleToggleSalesforceSyncFlag(e.target.checked);
  };

  componentDidMount() {
    const { isExe, isEnableSyncSetting, exeExportMappingsFlag, addressImportMappingsFlag } = this.props;

    let { disableSwitch, warningMessage, salesforceSyncFlag } = this.state;

    if (isEnableSyncSetting) {
      if (isExe && !exeExportMappingsFlag) {
        disableSwitch = true;
        salesforceSyncFlag = false;
        warningMessage = SalesforceSyncControl.WARNING_MESSAGE.NOT_SETTING_EXE_MAPPING;
      } else if (!isExe && !addressImportMappingsFlag) {
        disableSwitch = true;
        salesforceSyncFlag = false;
        warningMessage = SalesforceSyncControl.WARNING_MESSAGE.NOT_SETTING_ADDRESS_IMPORT_MAPPING;
      } else {
        disableSwitch = false;
        salesforceSyncFlag = true;
        warningMessage = "";
      }
    } else {
      disableSwitch = true;
      salesforceSyncFlag = false;
      warningMessage = SalesforceSyncControl.WARNING_MESSAGE.NOT_SETTING;
    }

    this.setState({
      salesforceSyncFlag: salesforceSyncFlag,
      warningMessage: warningMessage,
      disableSwitch: disableSwitch,
    });

    this.props.handleToggleSalesforceSyncFlag(salesforceSyncFlag);
  }

  render() {
    const { classes } = this.props;
    const { disableSwitch, warningMessage, salesforceSyncFlag } = this.state;

    return (
      <div className={classes.root}>
        <div className={classes.item}>
          <div
            className={classes.label}
            style={{ color: salesforceSyncFlag ? "#1A65FF" : "rgba(0, 0, 0, 0.54)" }}
          >
            Salesforceに同期する
          </div>
          <ArrowToolTip
            style={{ margin: "-2px 2px 0px 2px" }}
            text={SalesforceSyncControl.SYNC_DESC}
            placement="top"
          >
            <HelpIcon
              width={15}
              height={15}
              color={salesforceSyncFlag ? "#1A65FF" : "#71737B"}
            />
          </ArrowToolTip>
        </div>

        <ArrowToolTip
          style={{ margin: "-2px 2px 0px 2px" }}
          text={warningMessage}
          placement="top"
        >
          <FormControlLabel
            control={
              <Switch
                checked={salesforceSyncFlag}
                onChange={this.handleToggleSalesforceSyncFlag}
                value="salesforce_sync_flag"
                color="primary"
                classes={{ root: classes.switchBase }}
                disabled={disableSwitch}
                title={warningMessage}
              />
            }
            className={classes.formControlLabel}
          />
        </ArrowToolTip>
      </div>
    );
  }
}

SalesforceSyncControl.propTypes = {
  classes: PropTypes.object.isRequired,
  isEnableSyncSetting: PropTypes.bool,
  addressImportMappingsFlag: PropTypes.bool,
  exeExportMappingsFlag: PropTypes.bool,
  isExe: PropTypes.bool,
  handleToggleSalesforceSyncFlag: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const user = state.accountSetting.user;
  return {
    isEnableSyncSetting: user && user.salesforce_integration_flag && user.integrations && user.integrations["salesforce"],
    addressImportMappingsFlag: state.salesforce.address_import_mappings_flag,
    exeExportMappingsFlag: state.salesforce.exe_export_mappings_flag,
  };
};

const mapDispatchToProps = () => {
  return {
  };
};

SalesforceSyncControl.WARNING_MESSAGE = {
  NOT_SETTING_EXE_MAPPING: "キーマンデータベースからの注文をSalesforceに同期するには、連携設定が必要です。「アカウント管理 > Salesforce連携」より設定してください。",
  NOT_SETTING_ADDRESS_IMPORT_MAPPING: "自社リストからの注文をSalesforceに同期するには、連携設定が必要です。「アカウント管理 > Salesforce連携」より設定してください。",
  NOT_SETTING: "Salesforce連携が未設定か、お客様現在のプランには含まれていません。",
};

SalesforceSyncControl.SYNC_DESC = "「Salesforceに同期する」オプションがオンの場合、この注文はSalesforceキャンペーンに同期されます。もし注文がキーマンデータベースから作られている場合、リストに含まれるキーマンも、指定されたSalesforceのオブジェクトに同期されます。もし注文が自社リストから作られていて、そして宛先にSalesforceによるインポートされたアドレスが1件も含まれていない場合、注文はSalesforceキャンペーンには同期されません。";

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesforceSyncControl));



// WEBPACK FOOTER //
// ./src/components/AddressBook/controls/SalesforceSyncControl.jsx